import { PubMsgResponse } from "@/websocket/model/messages/responses";
import { ChannelType } from "@/websocket/model/enums/channel-type";
import { SubjectType } from "@/websocket/model/enums/subject-type";
import { useApiStore } from "@/api/stores/use-api-store";
import {
    BetCashBody,
    ClockBody,
    EventBody,
    MarketBody,
    OutcomeBody,
    PriceBody,
    ScoreBody,
} from "@/websocket/model/messages/body";

// Websocket data mapping can be turned off here... For debugging purposes only!
const MAPPING_ENABLED = import.meta.env.VITE_DISABLE_WEBSOCKET_DATA_MAPPING !== "true";

export default function usePubMsgResponseMapper() {
    const apiStore = useApiStore();

    const updateStoreData = (res: PubMsgResponse) => {
        switch (res.subject.type) {
            case SubjectType.Evall: // Not sure whether this subject type even exists... but it's in the documentation
            case SubjectType.Event:
                apiStore.updateEvent(res.messageId, res.channel.id, res.body as EventBody);
                break;
            case SubjectType.Market:
                apiStore.updateEventMarket(res.messageId, res.channel.id, res.subject.id, res.body as MarketBody);
                break;
            case SubjectType.Outcome:
                apiStore.updateEventOutcome(res.messageId, res.channel.id, res.subject.id, res.body as OutcomeBody);
                break;
            case SubjectType.Price:
                apiStore.updateEventPrice(res.messageId, res.channel.id, res.subject.id, res.body as PriceBody);
                break;
            case SubjectType.Score:
                apiStore.updateEventScore(res.messageId, res.subject.id, res.body as ScoreBody);
                break;
            case SubjectType.Clock:
                apiStore.updateEventClock(res.messageId, res.subject.id, res.body as ClockBody);
                break;
            case SubjectType.BetCash:
                apiStore.updateBetCash(res.messageId, res.body as BetCashBody);
                break;
            default:
                // These are known subjects which we ignore purposely
                if (
                    ![SubjectType.Handicap, SubjectType.Eppnt, SubjectType.Stats, SubjectType.Pturn].includes(
                        res.subject.type,
                    )
                ) {
                    console.log(res.body);
                    // Shouldn't happen, but we need to be aware if it happens and resolve during development
                    throw new Error(`Unknown subject type '${res.subject.type}'!!!`);
                }
        }
    };

    const mapToStore = (res: PubMsgResponse) => {
        if (!MAPPING_ENABLED) return;
        // Maybe refactor to something like apiStore.updateBySubject(res.subject.type, res.subject.id, res.body); or delete this mapper completely and integrate to store
        if (
            [
                ChannelType.Evall,
                ChannelType.EvallDescendants,
                ChannelType.Event,
                ChannelType.EventDescendants,
                ChannelType.Market,
                ChannelType.Cashout,
            ].includes(res.channel.type)
        ) {
            updateStoreData(res);
        } else {
            console.log(res.body);
            throw new Error(`Unknown channel type '${res.channel.type}'!!!`);
        }
    };

    return { mapToStore };
}
